import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { CatalogPage, useCatalogIndex } from "@/modules/Catalog";

// All series. `/catalog` would have been the natural URL, but it is an iOS
// universal link (public/.well-known/apple-app-site-association) that must
// keep opening the app, so it stays the "app only" page.
export const Route = createFileRoute("/_default/series/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { shows, loading, error } = useCatalogIndex();

  return (
    <CatalogPage
      kind="all"
      title={t("catalog_all_series_title")}
      shows={shows}
      loading={loading}
      error={error}
    />
  );
}
